<template>
  <div id="credit_1372">
    <AddEntity
      ref="addEntity"
      entity-name="credit1372"
      :display-button="false"
      @refresh="
        $store.dispatch(`${namespace}/fetchData`);
        $emit('refresh');
      "
    />
    <b-row>
      <b-col
        id="total"
        cols="12"
      >
        <strong>Total&nbsp;: </strong>
        <output>{{ total | moneyFilter }}&nbsp;$</output>
      </b-col>
      <b-col cols="12">
        <GenericTable
          endpoint-url="/credit1372"
          :name="namespace"
          :actions="actions"
          :colonnes="colonnes"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters"
          :display-archive-checkbox="false"
          right-button
          @action-callback="dispatchAction"
          @row-click="openDetails"
        >
          <button
            class="btn right-button"
            @click="exportSimple"
          >
            Exporter tous les crédits 1372
          </button>
        </GenericTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";

import mixinBudget from "@/mixins/mixinBudget";

import { roundNumber, verboseColCreditForTable } from "@/modules/utils";

export default {
  name: "Credit1372",
  components: { GenericTable },
  mixins: [mixinBudget],
  data() {
    return {
      namespace: "Budget1372Credit",
      colonnes: [
        { key: "date_reception", defaultOrder: true },
        { key: "libelle" },
        { key: "montant_euros" },
        { key: "taux_change" },
        { key: "montant_dollars" },
      ],
      filterableCol: ["libelle", "date_reception"],
    };
  },
  computed: {
    extraFilters() {
      if (this.annee === null) {
        return {
          budget: 1372,
          date_reception__isnull: true,
        };
      }
      return {
        date_reception__gte: `01/10/${this.annee - 1}`,
        date_reception__lte: `30/09/${this.annee}`,
      };
    },
    total() {
      return roundNumber(this.infoBudgets[1372].credits);
    },
  },
  mounted() {
    this.$store.commit(
      `${this.namespace}/setFormatDataFunction`,
      verboseColCreditForTable,
    );
  },
};
</script>

<style lang="scss">
#credit_1372 .table-content {
  .date_reception { width: 300px; }
  .libelle { min-width: 300px; }
  .montant_dollars,
  .montant_euros { width: 300px; }
  .taux_change { width: 300px; }
}
</style>
